import { config } from '../../config';

export const backendUrls = {
    USER_ADMINISTRATION: config.backend.USER_ADMIN,
    ACCOUNTS_SERVICE: config.backend.ACCOUNTS_SERVICE,
    TAGS_SERVICE: config.backend.TAG_SERVICE,
    AUTH_SERVER: config.backend.AUTH_SERVER,
};
